var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"back"},[_c('a',{attrs:{"href":'/apps/smartlinks/global-offers-v2'}},[_c('i',{staticClass:"fa fa-chevron-circle-left back-btn-2",attrs:{"aria-hidden":"true"}})])]),_c('h2',[_vm._v("Global Offers")]),_c('GlobalOfferMain')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }